export default "__VITE_ASSET__124baf87__"